import { useContext } from 'react';
import { makeStyles } from '@mui/styles';
import Section from '@classify/react-core-components/Section';
import { RichContent } from '@openclassrooms/ui-web/rich-content';
import { InsetPicturedContent } from '@openclassrooms/ui-web/ui';
import Typography from '@classify/react-core-components/Typography';
import ContentWrapper from '@classify/react-core-components/ContentWrapper';
import { translate } from '@openclassrooms/translations';
import CourseContext from '../../contexts/courseContext';
import LearningOutcomes from '../LearningOutcomes';
import requirements from '../../images/requirements.svg';

const useStyles = makeStyles(({ breakpoints, spacing, palette }) => ({
  descriptionContainer: {
    width: '100%',
    marginBottom: spacing(5),
    [breakpoints.up('md')]: {
      width: 768,
    },
    [breakpoints.up('lg')]: {
      marginBottom: spacing(6),
    },
  },
  title: {
    width: '100%',
    marginBottom: spacing(3),
    paddingBottom: spacing(1),
    borderBottom: `1px solid ${palette.divider}`,
  },
  pictureContainer: {
    margin: 0,
    [breakpoints.up('sm')]: {
      alignSelf: 'start',
    },
  },
  prerequisitesContainer: {
    flexDirection: 'column-reverse !important' as 'column-reverse',
    marginTop: spacing(5),
    [breakpoints.up('sm')]: {
      flexDirection: 'row !important' as 'row',
      justifyContent: 'flex-start',
    },
    [breakpoints.up('md')]: {
      marginTop: spacing(7),
    },
    [breakpoints.up('lg')]: {
      marginTop: spacing(9),
    },
  },
  prerequisitesContent: {
    width: '100%',
    maxWidth: '100%',
    margin: spacing(0, 0, 0, 4),
    [breakpoints.up('sm')]: {
      margin: spacing(0, 0, 0, 7),
    },
  },
  richContent: {
    '& > p': {
      marginBottom: spacing(2),
    },
    [breakpoints.up('sm')]: {
      maxWidth: 768,
    },
  },
}));

const CourseOverview = () => {
  const classes = useStyles();
  const { course, description } = useContext(CourseContext);

  const { prerequisite } = course;

  return (
    <Section>
      <ContentWrapper>
        {description && (
          <div className={classes.descriptionContainer}>
            <RichContent
              content={description}
              className={classes.richContent}
              shouldZoomIntoImage
            />
          </div>
        )}

        <LearningOutcomes />

        {prerequisite && (
          <InsetPicturedContent
            pictureUrl={requirements}
            classes={{
              root: classes.prerequisitesContainer,
              pictureContainer: classes.pictureContainer,
              content: classes.prerequisitesContent,
            }}
          >
            <Typography variant="h3" className={classes.title} component="h2">
              {translate('course.overview.requirements.title')}
            </Typography>
            <RichContent content={prerequisite} className={classes.richContent} />
          </InsetPicturedContent>
        )}
      </ContentWrapper>
    </Section>
  );
};

export default CourseOverview;
